import {
  Context,
  useBillingFactory,
  UseBillingParams
} from '@vue-storefront/core';
import type { BillingAddress } from '@bee-hole/api';
import type {
  UseBillingAddParams as AddParams
} from '../types';
import { useApiError } from '../useApiError';
import { useUserShipping } from '../useUserShipping';

const params: UseBillingParams<BillingAddress, AddParams> = {
  provide: () => ({
    useApiError: useApiError(),
    useUserShipping: useUserShipping()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context, { customQuery }) => {
    await context.useUserShipping.load(customQuery);
    return context?.useUserShipping?.shipping?.value;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  save: async (context: Context, { params, billingDetails, customQuery }) => {
    await context.useUserShipping.addAddress({ address: billingDetails });
    const result = await params.load(context, { customQuery });
    return result;
  }
};

export const useBilling = useBillingFactory<BillingAddress, AddParams>(params);
